var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edp-tree"},[_c('edp-tree-children',_vm._g({attrs:{"data":_vm.data,"deep":0,"children-key":_vm.childrenKey,"flag":_vm.flag,"row-key":_vm.rowKey},scopedSlots:_vm._u([{key:"default",fn:function({row, open, fun}){return [_vm._t("default",null,{"row":row,"open":open,"fun":fun})]}}],null,true)},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }